import { useWizard } from "react-use-wizard";
import {
  TBooleanKeysOfIFillDataWizardBuy,
  TKeyOfDataWizardBuy,
} from "../../..";
import buySteps from "../../buySteps";
import FinanceStep from "../../../../../../../shared/wizard/steps/financeStep";

interface ISelectionByOwnBuyStep_7 {
  onChange: (data: boolean, key: TBooleanKeysOfIFillDataWizardBuy) => void;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
  data: boolean | null;
  isNextStepDisabled: boolean;
  triplePrevStep: boolean;
}

const SelectionByOwnBuyStep_7 = ({
  isNextStepDisabled,
  data,
  triplePrevStep,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_7) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(
      triplePrevStep
        ? buySteps.selectionSteps.buy.step_4
        : buySteps.selectionSteps.buy.step_6
    );
    onReset(["finance"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_8);
  };

  return (
    <div>
      <FinanceStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        data={data}
        isNextStepDisabled={isNextStepDisabled}
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_7;
